import ShImage from "../../../components/image/shImage";

const Image = ( { url, width, alt } ) => {

    if(!url){
        return null;
    }

    let className;

    if( width === "25") {
        className = "col-12 col-md-6 col-lg-3";
    } else if( width === "33"){
        className = "col-12 col-md-6 col-lg-4";
    } else if( width === "50"){
        className = "col-12 col-md-6";
    } else if( width === "75") {
        className = "col-12 col-md-8";
    }

    if(width){
        return <div className="row">
            <div className={className}>
                <ShImage url={url} className={"border-radius"} fullWidth={true} />
            </div>
        </div>
    } else{
        return  <ShImage url={url} className={"border-radius"} fullWidth={true} />
    }

};

export default Image;